import React, { useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

import LocationOn from "@material-ui/icons/LocationOn";
import AccessTime from "@material-ui/icons/AccessTime";
import Call from "@material-ui/icons/Call";

const items = [
  {
    name: "Piroshky Piroshky HQ",
    address: (
      <span>
        1501 4th Avenue, Suite 2840
        <br />
        Seattle, WA 98101
      </span>
    ),
    lat: 47.61044701322972,
    lng: -122.33712951917,
    phone: "(206) 764-1000",
    hours: (
      <span>
        <div className="u-flexCenter u-justifyContentSpaceBetween">
          <span>Mon - Fri</span>
          <span>8:00 am - 4:00 pm</span>
        </div>
      </span>
    ),
    description:
      "Primary Office for all Piroshky Locations. For pick and and deliveries, please order from our Century Square Bakery, located in the same building on the 1st floor.",
  },
  {
    name: "Pike Place Market",
    address: (
      <span>
        1908 Pike Place <br /> Seattle, WA 98101
      </span>
    ),
    lat: 47.60994657091181,
    lng: -122.34240557992925,
    phone: "(206) 441-6068",
    hours: (
      <span>
        <div className="u-flexCenter u-justifyContentSpaceBetween">
          <span>Mon - Sun</span>
          <span>8:00 am - 7:00 pm</span>
        </div>
      </span>
    ),
    description:
    "Located in the Pike Place at the corner of Pike Place and Stewart Street.",
  },
  {
    name: "Century Square | 3rd & Pike",
    address: (
      <span>
        Century Square
        <br />
        1501 4th Avenue, Suite 110
        <br />
        Seattle, WA 98101
      </span>
    ),
    lat: 47.61044701322972,
    lng: -122.33712951917,
    phone: "(206) 466-1655",
    hours: (
      <span >
        <div className="u-flexCenter u-justifyContentSpaceBetween">
          <span>Mon - Fri</span>
          <span>8:00 am - 4:00 pm</span>
        </div>
      </span>
    ),
    description:
      "Located in the Century Square in food court, directly accessible by the building's Third Avenue entrance or sidewalk service window.",
  },
  {
    name: "Columbia Tower",
    address: (
      <span>
        Columbia Tower
        <br />
        701 5th Avenue, Suite 104
        <br />
        Seattle, WA 98104
      </span>
    ),
    lat: 47.60449677014453,
    lng: -122.33046984434701,
    phone: "(206) 467-1319",
    hours: (<>
      <div className="u-flexCenter u-justifyContentSpaceBetween">
        <span>Mon & Fri</span>
        <span>8:00 am - 2:00 pm</span>
        <br/>
      
      </div>
      <div className="u-flexCenter u-justifyContentSpaceBetween">
      <span>Tue - Thur</span>
      <span>7:00 am - 3:00 pm</span>
      <br/>
    
    </div>
    </>
  ),
    description:
      "Located on the first floor of Columbia Center in The Atrium food court, directly accessible by the building's Fourth Ave entrance.",
  },
  {
    name: "Kent",
    address: (
      <span>
        26002 Pacific Hwy S. <br /> Kent, WA 98032
      </span>
    ),
    lat: 47.368430,
    lng: -122.302580,
    phone: "(206) 441-6068",
    hours: (
      <span>
       
      </span>
    ),
    description:
    "Located in the Kent off of Pacific Highway South. Currently we only are accepting pick up orders made through our website. Thank you :)",
  },
  {
    name: "Convention Center",
    address: (
      <span>
        Convention Center
        <br />
        1000 Pine, Suite 433
        <br />
        Seattle, WA 98101
      </span>
    ),
    lat: 47.6144207,
    lng: -122.3302785,
    phone: "(206) 264-1000",
    hours: (<>
        <div className="u-flexCenter u-justifyContentSpaceBetween">
          <span>Mon - Fri</span>
          <span>9:00 am - 5:00 pm</span>
          <br/>
        
        </div>
        <div className="u-flexCenter u-justifyContentSpaceBetween">
        <span>Sat & Sun</span>
        <span>10:00 am - 5:00 pm</span>
        <br/>
      
      </div>
      </>
    ),
    description:
      "We are between 9th and Boren Ave on Pine. This building is the Summit building of the convention center",
  },

];

export const LocationList = (props) => {
  return (
    <div>
      {items.map((item, i) => {
        return (
          <div
            key={i}
            className="u-flexCenter u-xs-flexColumn u-justifyContentSpaceBetween u-paddingTop40 u-paddingBottom40 u-borderTop1 u-borderColorLighter"
          >
            <div
              className="u-flexColumn u-xs-maxWidthNone"
              style={{ maxWidth: 300 }}
            >
              <span className="u-fontWeightBold u-fontSize18">{item.name}</span>
              <span className="u-flexCenter u-marginVertical8">
                <LocationOn className="u-marginRight8 u-textColorNormal" />
                {item.address}
              </span>
              <span className="u-flexCenter u-marginVertical8">
                <Call className="u-marginRight8 u-textColorNormal" />
                {item.phone}
              </span>
              <span className="u-marginVertical8">
                <span className="u-flexCenter u-marginBottom5">
                  <AccessTime className="u-marginRight8 u-textColorNormal" />
                  Hours:
                </span>
                {item.hours}
              </span>
              <span className="u-marginVertical8">{item.description}</span>
            </div>

            <div
              className="u-marginLeft80 u-xs-marginLeft0 u-xs-marginTop20"
              style={{ height: "300px", width: "100%" }}
            >
              <MapWidget {...props} item={item} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export function MapWidget(props) {
  const { item } = props;
  const [map, setMap] = useState(null);

  const containerStyle = {
    width: "100%",
    height: "300px",
  };

  const center = {
    lat: item.lat,
    lng: item.lng,
  };

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter(new google.maps.LatLng(47, 116.3974589));
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return (
    <LoadScript googleMapsApiKey="AIzaSyAni95BiWla14z0UKlgF-wrt51hRQueOVc">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={13}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <Marker onLoad={() => console.log()} position={center} />
      </GoogleMap>
    </LoadScript>
  );
}
